export const SchedulingValidation = {
  MissingTeam: 'MISSING_TEAM',
  EmptyTeam: 'EMPTY_TEAM',
  NoAvailability: 'NO_AVAILABILITY',
  TeamUnavailable: 'TEAM_UNAVAILABLE',
  MissingEstimation: 'MISSING_ESTIMATION',
  InvalidTargetDates: 'INVALID_TARGET_DATES',
  ItemIsDone: 'ITEM_IS_DONE',
  ParentUnschedulable: 'PARENT_UNSCHEDULABLE',
  DependencyUnschedulable: 'DEPENDENCY_UNSCHEDULABLE',
  CircularDependency: 'CIRCULAR_DEPENDENCY',
  OutsideCalendarLimits: 'OUTSIDE_CALENDAR_LIMITS',
} as const;

export type SchedulingValidation = (typeof SchedulingValidation)[keyof typeof SchedulingValidation];
